import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectList } from 'src/app/globalClass/select-list';
import { AdmCategoryService } from 'src/app/globalService/adm-category.service';
import { Select2OptionData } from 'ng-select2';
import { Options } from 'select2'
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { TableEmpresaService } from './shared/table-empresa.service';
import { UserComercialService } from './shared/user-comercial.service';
import { CiudadesServiceService } from 'src/app/parametricas/ciudades/shared/ciudades-service.service';
import { ToastrService } from 'ngx-toastr';
import { GenericResult } from 'src/app/globalClass/generic-class.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { InfoUserService } from 'src/app/info-user/shared/info-user.service';
import { VariablesService } from 'src/app/globalService/variables.service';
import { UserService } from 'src/app/users/shared/user.service';

@Component({
  selector: 'app-user-comercial',
  templateUrl: './user-comercial.component.html',
  styleUrls: ['./user-comercial.component.css']
})
export class UserComercialComponent implements OnInit {

  add: boolean = false;
  edit: boolean = false;

  listTypeDocument: SelectList[];
  listTipoPersona:any[]=[];
  listCitys: Array<Select2OptionData>;
  singleOptions: Options;
  listUsers:any[] = [];
  listTipoPersonaFake:any[] = [];
  isLoader = false;
  messageLoader = "Guardando...";

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();


  constructor(
    private _fb:FormBuilder,
    private categoryService: AdmCategoryService,
    private _tableEmpresaService:TableEmpresaService,
    private _userComercialService:UserComercialService,
    private _ciudadService: CiudadesServiceService,
    private _toastr:ToastrService,
    private chRef:ChangeDetectorRef,
    private _variables: VariablesService,
    private userInfo: InfoUserService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    debugger;
    this.initDatatable();
    this.loadListTipoPersonaFake();
    //this.loadListTipoPersona();
    this.loadSelectListTypeDocument();
    this.loadCities();
  }

  userForm: FormGroup = this._fb.group({
    IdSegUsuario: [0],
    IdSegTipoPersona: [null,Validators.required],
    IdTipoDocumento: [null, Validators.required],
    NumeroDocumento: ['', Validators.required],
    Nombre: ['', Validators.required],
    Apellido1: ['', Validators.required],
    Apellido2: [''],
    Telefono: [''],
    CorreoElectronico: ['', [Validators.required, Validators.email]],
    ConfirmarCorreoElectronico: ['', [this.equalsTo('CorreoElectronico'), Validators.required]],
    Cargo: [null,Validators.required],
    roles: 0,
    companys: [this._tableEmpresaService.getCompanys()],
    SegRolUsuario: null,
    SegUsuarioEmpresa:null,
    Ciudad: [null, Validators.required],
    idAdmEstado:null,
    esUsuarioActivo:null,
    domainUserName:''
  });

  test(){
    return console.log(this.userForm);
  }

  companys(){
    return [];
  }

  loadListTipoPersonaFake(){
    this.listTipoPersonaFake.push({id:0,name:"Seleccione Tipo persona"});
    this.listTipoPersonaFake.push({id:1,name:"Persona Natural"});
    this.listTipoPersonaFake.push({id:2,name:"Persona Jurídica"});
  }

  onChangeTipoPersona(event){
    let value = event.target.value;
    this.listTipoPersona = [];
    if(value != 0){
      this.loadListTipoPersona(value);
    }
  }

  async loadListTipoPersona(value:number){
    this._userComercialService.GetTipoUsuarioUserComercial().then(
      (r:any) => {
        if(value == 1){
          this.listTipoPersona = r.filter(x=> x.idSegTipoPersona == 7);
        }else{
          this.listTipoPersona = r.filter(x=> x.idSegTipoPersona != 7 && x.idSegTipoPersona != 3);
        }
      }
    );
  }

  equalsTo(otherField: string) {
    const validator = (formControl: FormControl) => {
      if (otherField == null) {
        throw new Error("Diligencie la información del campo");
      }
      if (!formControl.root || !(<FormGroup>formControl.root).controls) {
        return null;
      }
      const field = (<FormGroup>formControl.root).get(otherField);
      if (!field) {
        throw new Error('Diligencie la información del campo');
      }
      if (field.value !== formControl.value) {
        return { equalsTo: otherField }
      }
      return null;
    };
    return validator;
  }

  loadCities() {
    this._ciudadService.getCitys2().then(r => this.loadCitiesArray(r));
  }

  loadSelectListTypeDocument() {
    this.categoryService.getListOfCategory(1).then(r => { this.listTypeDocument = r as SelectList[] });
  }

  onSubmit() {
    debugger;
    this.isLoader = true;
    if(this.userForm.get("companys").value.length>0){
      if(!this.edit){
        this.insertRecord();
      }else{
        this.updateRecord();
      }
    }else{
      this.isLoader = false;
      this._toastr.warning("Para realizar el registro debe agregar al menos una empresa.");
    }
  }

  loadCitiesArray(objectData: any) {
    if (objectData != null) {
      this.listCitys = [];
      for (var i = 0; i < objectData.length; i++) {
        this.listCitys.push({ id: objectData[i].idAdmCiudad, text: objectData[i].nombre });
      }
    }
  }

  insertRecord() {
    this.userForm.patchValue({
      SegUsuarioEmpresa:this.toArraCompany()
    });
    this.userInfo.getUserInfo();
    let idUser = this.userInfo.infoUser.idUser;
    this._userComercialService.saveUserComercial(this.userForm.value,idUser).then((r:GenericResult)=>{
      if(r.error){
        if(r.result == 'errorUserExist'){
          this.isLoader = false;
          this._toastr.warning("El usuario que usted está registrando ya se encuentra creado, por favor solicite al correo soporte portal web el cambio de administración de usuario, para fines pertinentes");
        }else if(r.result == 'errorRL'){
          this.isLoader = false;
          this._toastr.warning("Ya existe un representante legal principal, si desea crear un nuevo usuario, debe seleccionar el tipo de cargo Responsable Sarlaft.");
        }
      }else{
        this._toastr.success("Guardado con éxito");
        this.resetForm();
        this.add = false;
        this.isLoader = false;
      }
    });
  }

  updateRecord(){
    this.userForm.patchValue({
      SegUsuarioEmpresa:this.toArraCompanyUpdate()
    });
    this._userComercialService.updateUserComercial(this.userForm.value,this.userForm.value.IdSegUsuario).then((r:GenericResult)=>{
      if(r.error){
        this.isLoader = false;
        this._toastr.error("Error al actualizar");
      }else{
        this.isLoader = false;
        this._toastr.success("Actualizado con éxito");
        this.resetForm();
        this.edit = false;
      }
    });
  }

  toArraCompany(){
    let companys = this.userForm.get("companys").value
    let temp = [];
    companys.forEach((ele) => {
      temp.push({ idAdmEmpresa: ele, activo: true });
    });
    return temp;
  }

  toArraCompanyUpdate(){
    let companys = this.userForm.get("companys").value
    let idUser = this.userForm.get("IdSegUsuario").value
    let temp = [];
    companys.forEach((ele) => {
      temp.push({ idAdmEmpresa: ele, activo: true,idSegUsuario:idUser });
    });
    return temp;
  }


  cancel() {
    this.add = false;
    this.edit = false;
    this.resetForm();
    this._tableEmpresaService.cleanList();
  }

  resetForm() {
    this.userForm.reset();
    this._tableEmpresaService.cleanList();
    this.userForm.patchValue({
      IdSegUsuario: 0,
      NumeroDocumento: '',
      Nombre: '',
      Apellido1: '',
      Apellido2: '',
      Telefono: '',
      CorreoElectronico: '',
      ConfirmarCorreoElectronico: '',
      roles: 0,
      companys: this._tableEmpresaService.getCompanys(),
      domainUserName:''
    });
    this.rerender();
  }

  loadUser(id: number) {
    this.getUserToUpdate(id);
    this.edit = true;
  }

  async getUserToUpdate(idUser:number){
    let idCity = this._variables.data.ciudad.bogota;
    this._userComercialService.getUsers(idUser).then((r:any) =>{
      let user = r;
      if(user.idSegTipoPersona == 7){
        $("#tipoPersonaFake").val(1);
        this.loadListTipoPersona(1);
      }else{
        $("#tipoPersonaFake").val(2);
        this.loadListTipoPersona(2);
      }
      this.userForm.patchValue({
        IdSegUsuario: user.idSegUsuario,
        IdSegTipoPersona: user.idSegTipoPersona,
        IdTipoDocumento: user.idTipoDocumento,
        NumeroDocumento: user.numeroDocumento,
        Nombre: user.nombre,
        Apellido1: user.apellido1,
        Apellido2: user.apellido2,
        Telefono: user.telefono,
        CorreoElectronico: user.correoElectronico,
        ConfirmarCorreoElectronico: user.correoElectronico,
        Cargo: user.cargo,
        Ciudad: idCity,
        esUsuarioActivo:user.esUsuarioActivo,
        domainUserName:user.domainUserName
      });
    });
    this._tableEmpresaService.setEmpresaByUser(idUser);
    
  }


  //DATATABLEINFO
  
  private initDatatable(): void {
    //debugger;
    let header = this.getHeader();
    this.userInfo.getUserInfo();
    let idUser = this.userInfo.infoUser.idUser;
    let idEmpresa = this.userInfo.infoUser.company.idAdmEmpresa;

    const that = this;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      serverSide: true,
      processing: true,
      ordering: false,
      ajax: (dataTablesParameters: any, callback) => {
        let data = { idEmpresa: idEmpresa, idUsuario: idUser };
        let temp = {
          datatable: dataTablesParameters,
          parameter: data
        };
        that.http
          .post<any>(
            `${this._variables.data.urlApi}SegUsuarios/GetUsersComercial`,
            temp, { headers: header }
          ).subscribe(resp => {
            that.listUsers = resp.data
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      }
    };
    this.chRef.detectChanges();
  }


  ngAfterViewInit(): void {
    //debugger
    this.dtTrigger.next(true);
    this.chRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    //debugger
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(true);
    });
  }
  
  getHeader() {
    let token = sessionStorage.getItem('jwt');
    // let publicIp = await this.ipService.getPublicIp();
    // let localIp = await this.ipService.getLocalIp();
    return new HttpHeaders({
      "Authorization": "Bearer " + token,
      "Content-Type": "application/json"
      // "PublicIp": publicIp,
      // "LocalIp": localIp
    })
  }
}
